// ======================================================================
// FILE:
// src/modules/service_crm/visits/components/VisitTable.js
//
// MODULE:
// Service CRM
//
// FEATURE:
// Service Visit Queue Table
// ======================================================================

import React from "react";

export default function VisitTable({

  rows = [],

  loading = false,

  onView,

  onAdd,

  onTicketDetails,

}) {

  return (

    <div

      style={{

        background: "#fff",

        borderRadius: 14,

        overflow: "hidden",

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",

      }}

    >

      <div className="table-responsive">

        <table
          className="table table-hover mb-0"
        >

          <thead
            className="table-light"
          >

            <tr>

              <th>
                Ticket No
              </th>

              <th>
                Customer
              </th>

              <th>
                Engineer
              </th>

              <th>
                Status
              </th>

              <th>
                Visit Count
              </th>

              <th>
                Last Visit
              </th>

              <th>
                Next Visit
              </th>

              <th>
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {loading && (

              <tr>

                <td
                  colSpan="8"
                  className="text-center"
                >
                  Loading...
                </td>

              </tr>

            )}

            {!loading &&
              rows.length === 0 && (

              <tr>

                <td
                  colSpan="8"
                  className="text-center"
                >
                  No Records Found
                </td>

              </tr>

            )}

            {!loading &&
              rows.map((row) => (

              <tr
                key={
                  row.ticket_id
                }
              >

                <td>
                  {row.ticket_no}
                </td>

                <td>
                  {row.customer_name}
                </td>

                <td>
                  {row.assigned_engineer}
                </td>

                <td>
                  {row.status}
                </td>

                <td>
                  {row.visit_count}
                </td>

                <td>

                  {row.last_visit_date

                    ? new Date(
                        row.last_visit_date
                      ).toLocaleDateString()

                    : "-"}

                </td>

                <td>

                  {row.next_visit_required
                    ? "Yes"
                    : "No"}

                </td>

                <td>

                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                    }}
                  >

                    

                    <button
                      className="
btn btn-sm btn-primary"
                      onClick={() =>
                        onAdd(row)
                      }
                    >
                      Add Visit
                    </button>
                    <button
                      className="
btn btn-sm btn-info"
                      onClick={() =>
                        onView(row)
                      }
                    >
                      View Visits
                    </button>
                    <button
  className="btn btn-sm btn-secondary"
  onClick={() => onTicketDetails(row)}
>
  Ticket Details
</button>

                  </div>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>

  );

}